import { HttpLink } from '@apollo/client';
import { getCsrfToken } from '@betterment/js-runtime';

export type Headers = Record<string, string>;

export const httpLink = (url: string, customHeaders: Headers) => {
  return new HttpLink({
    credentials: 'include',
    headers: {
      'X-CSRF-Token': getCsrfToken() || '',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      ...customHeaders,
    },
    uri: url,
  });
};
